import { MenuItem } from 'interfaces';
import CollapsedNavItem from './CollapsedNavItem';
import SideNavDivider from './SideNavDivider';
import { getItemKey, NavGroup } from 'utils/navBar/sideNav.util';

interface CollapsedNavRailProps {
  navGroups: NavGroup[];
  adminItem: MenuItem | null;
  renderSubMenuStyle: (subPath?: string) => string;
}

const renderRailItem = (
  item: MenuItem,
  renderSubMenuStyle: (subPath?: string) => string
) => (
  <CollapsedNavItem
    key={getItemKey(item)}
    path={item.path}
    text={item.text ?? undefined}
    subMenus={item.subMenus}
    attribAction={item.attribAction}
    icon={item.icon}
    renderSubMenuStyle={renderSubMenuStyle}
  />
);

const CollapsedNavRail = ({
  navGroups,
  adminItem,
  renderSubMenuStyle
}: CollapsedNavRailProps) => {
  const rail = navGroups.flatMap((group, index) => {
    const items = group.railItems.map((item) =>
      renderRailItem(item, renderSubMenuStyle)
    );
    if (index === 0) return items;
    return [
      <SideNavDivider key={`divider-${group.id}`} id={`divider-${group.id}`} />,
      ...items
    ];
  });

  if (adminItem) {
    rail.push(
      <SideNavDivider key='divider-admin' id='divider-admin' />,
      renderRailItem(adminItem, renderSubMenuStyle)
    );
  }

  return <>{rail}</>;
};

export default CollapsedNavRail;
